export const friendlyErrorMessages = {
  'auth failure': 'Your email or password is incorrect',
  'Menu Item Not Found': 'We were unable to load this item',
  'Reward with id  not found': 'Unable to add reward',
  'expired token': 'Your reset password link has expired',
  'used token': 'This reset password link has already been used',
};
